<template>
  <div
    :class="[
      'top-0 left-0 h-full w-64 transition-transform ease-in-out duration-300 z-50 relative xs:fixed xs:!border-r-0 sm:fixed sm:!border-r-0 md:fixed md:!border-r-0 lg:fixed',
      // cData.isCollapsed ? 'translate-x-0' : '-translate-x-full',
      'sidebar-llm-custom',
      props.className,
    ]"
    :style="[props.inlineStyles]"
  >
    <div class="sidebar-section flex flex-col h-full">
      <div class="flex w-full justify-between items-center mb-8 sidebar-header flex-none">
        <div class="flex gap-2 items-center">
          <img src="/images/icons/ic-purple-diamond.svg" />
          <h2 class="text-1.5xl font-bold text-white"> AI Assistant</h2>
        </div>
        <div
          class="bg-white rounded-full w-[24px] h-[24px] flex items-center justify-center cursor-pointer hover:bg-slate-200 hover:scale-110 transition-all"
          @click="toggleSidebar"
        >
          <img src="/images/icons/ic-chevron-left-area-outline-purple.svg" />
        </div>
      </div>
      <div
        class="sidebar-lists flex-1 flex flex-col min-h-0 overflow-hidden"
        :style="[
          props.heightItem && {
            height: `${props.heightItem} ${
              props.heightItemUnit ? props.heightItemUnit : 'px'
            }`,
          },
        ]"
      >
        <div
          :class="['button-box  is-selected flex-none', {}]"
          @click="onClickCreateConversation"
        >
          <div :class="['sidebar-button', {}]">
            <div class="sidebar-image flex-none">
              <img
                :src="'/images/icons/ic-plus-small-area-outline.svg'"
                alt="Icon"
              />
            </div>
            <div class="sidebar-text flex-1">Create Conversation</div>
          </div>
        </div>

        <!-- <div v-if="!cData.isShowInputSearch" class="my-4 flex justify-between"> -->
          <!-- Start Prompt Starter -->
        <div v-show="!!props.promptStartList.length" class="my-4 flex justify-between flex-none">
          <span class="text-white text-1.5xl font-medium">Favorite</span>
          <img
            class="min-w-6 min-h-6 max-w-6 max-h-6 cursor-pointer"
            src="/images/icons/ic-search-outline-white.svg"
            alt="search"
            @click="
              () => {
                cData.isShowInputSearchPromptStart = true;
              }
            "
          />
        </div>
        <div v-show="!!props.promptStartList.length" class="overflow-y-auto space-y-2 min-h-12 max-h-28 flex-shrink-0 rounded-xl gap-4">
            <div
              v-for="(ec, ic) in props.promptStartList"
              :key="ic"
              class="flex space-x-2 justify-between items-center"
            >
              <div
                :class="['button-box-conversation space-y-4 flex-1 group relative',
                  {
                    'pointer-events-none opacity-50': !gConversationData.modelActiveName,
                  }
                ]"
                @click="
                  () => {
                    props.onClickPromptStart(ec);
                  }
                "
              >
                <div
                  :class="[
                    'sidebar-button items-start',
                    {
                      'opacity-80': !(ec.id === gPromptStartActiveId),
                      'is-selected-oth rounded-full':
                        ec.id === gPromptStartActiveId,
                    },
                  ]"
                >
                  <div
                    class="sidebar-text flex-1 line-clamp-1 break-all"
                    :title="ec.message"
                  >
                    {{ ec.message }}
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- End Prompt Starter -->
        <!-- Start Room -->
        <div class="my-4 flex justify-between flex-none">
          <span class="text-white text-1.5xl font-medium"> Room</span>
          <img
            class="min-w-6 min-h-6 max-w-6 max-h-6 cursor-pointer"
            src="/images/icons/ic-search-outline-white.svg"
            alt="search"
            @click="
              () => {
                cData.isShowInputSearchRoom = true;
              }
            "
          />
        </div>
        <div class="overflow-y-auto space-y-2 min-h-12 max-h-28 flex-shrink-0 rounded-xl gap-4">
          
            <div
              v-for="(ec, ic) in props.roomList"
              :key="ic"
              class="flex space-x-2 justify-between items-center"
            >
              <div
                :class="'button-box-conversation space-y-4 flex-1 group relative'"
                @click="
                  () => {
                    props.onClickRoom(ec);
                  }
                "
              >
                <div
                  :class="[
                    'sidebar-button items-start',
                    {
                      'opacity-80': !(ec.data.presetId === gPresetActiveId),
                      'is-selected-oth rounded-full':
                        ec.data.presetId === gPresetActiveId ,
                    },
                  ]"
                >
                  <div
                    class="sidebar-text flex-1 line-clamp-1 break-all"
                    :title="ec.text"
                  >
                    {{ ec.text }}
                  </div>
                </div>
              </div>
            </div>
        </div>

        <!-- End Room  -->
        <div class="my-4 flex justify-between flex-none">
          <span class="text-white text-1.5xl font-medium">General History</span>
          <img
            class="min-w-6 min-h-6 max-w-6 max-h-6 cursor-pointer"
            src="/images/icons/ic-search-outline-white.svg"
            alt="search"
            @click="handleSearchGeneral"
          />
        </div>
        <div 
          ref="generalListRef"
          class="overflow-y-auto space-y-4 flex-1 min-h-0 rounded-xl gap-4"
          @scroll="handleScrollGeneral"
        >
          <template v-for="(e, i) in generalGroupList" :key="i">
            <div
              v-if="e.groupName && e.dataList.length"
              class="p-2 border-b border-b-white"
            >
              <span class="text-white font-bold text-sm">{{
                e.groupName
              }}</span>
            </div>
            <div
              v-for="(ec, ic) in e.dataList"
              :key="ic"
              class="flex space-x-2 justify-between items-center"
            >
              <div
                :class="'button-box-conversation space-y-4 flex-1 group relative'"
                @click="
                  () => {
                    props.onClickSubMenu(ec);
                  }
                "
              >
                <div
                  :class="[
                    'sidebar-button items-start',
                    {
                      'opacity-80': !(ec.id === gConversationActiveId),
                      'is-selected rounded-full':
                        ec.id === gConversationActiveId,
                    },
                  ]"
                >
                  <div class="sidebar-image flex-none">
                    <img
                      v-if="ec.id === gConversationActiveId"
                      :src="ec.icon"
                      alt="Icon"
                    />
                    <img v-else :src="ec.iconDefault" alt="Icon" />
                  </div>
                  <div
                    class="sidebar-text flex-1 line-clamp-1 break-all"
                    :title="ec.name"
                  >
                    {{ ec.name }}
                  </div>
                  
                  <img
                    class="w-6 h-6 p-1 opacity-0 hover:opacity-100 "
                    :class="`${ ec.id === gConversationActiveId ? 'opacity-100' : 'opacity-0'} `"
                    src="/images/icons/ic-ellipsis-vertical-area-fill.png"
                    @click.stop="(event) => toggleOperation(event, ec)"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- End General -->
        <div class="my-4 flex justify-between flex-none">
          <span class="text-white text-1.5xl font-medium">Room History</span>
          <img
            class="min-w-6 min-h-6 max-w-6 max-h-6 cursor-pointer"
            src="/images/icons/ic-search-outline-white.svg"
            alt="search"
            @click="handleSearchConversation"
          />
        </div>
        <div 
          ref="conversationListRef"
          class="overflow-y-auto space-y-4 flex-1 min-h-0 rounded-xl gap-4"
          @scroll="handleScrollRoom"
        >
          <template v-for="(e, i) in conversationGroupList" :key="i">
            <div
              v-if="e.groupName && e.dataList.length"
              class="p-2 border-b border-b-white"
            >
              <span class="text-white font-bold text-sm">{{
                e.groupName
              }}</span>
            </div>
            <div
              v-for="(ec, ic) in e.dataList"
              :key="ic"
              class="flex space-x-2 justify-between items-center"
            >
              <div
                :class="'button-box-conversation space-y-4 flex-1 group relative'"
                @click="
                  () => {
                    props.onClickSubMenu(ec);
                  }
                "
              >
                <div
                  :class="[
                    'sidebar-button items-start',
                    {
                      'opacity-80': !(ec.id === gConversationActiveId),
                      'is-selected rounded-full':
                        ec.id === gConversationActiveId,
                    },
                  ]"
                >
                  <div class="sidebar-image flex-none">
                    <img
                      v-if="ec.id === gConversationActiveId"
                      :src="ec.icon"
                      alt="Icon"
                    />
                    <img v-else :src="ec.iconDefault" alt="Icon" />
                  </div>
                  <div
                    class="sidebar-text flex-1 line-clamp-1 break-all"
                    :title="ec.name"
                  >
                    {{ ec.name }}
                  </div>
                  
                  <img
                    class="w-6 h-6 p-1 opacity-0 hover:opacity-100 "
                    :class="`${ ec.id === gConversationActiveId ? 'opacity-100' : 'opacity-0'} `"
                    src="/images/icons/ic-ellipsis-vertical-area-fill.png"
                    @click.stop="(event) => toggleOperation(event, ec)"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div
      v-if="cData.operation.show"
      class="sidebar-operation flex flex-col gap-2"
      :style="{
        top: `${cData.operation.position.top}px`,
        left: `${cData.operation.position.left}px`,
      }"
    >
      <div
        class="flex gap-2 p-2 cursor-pointer hover:bg-[#CC00991A] hover:rounded-2xl"
        @click="props.onClickRenameConversation(cData.operation.activeMenu)"
      >
        <img
          class="min-w-5 min-h-5 max-w-5 max-h-5"
          src="/images/icons/ic-pencil-area-fill.svg"
          alt="delete"
        />
        <span class="text-[#9457EB] text-sm"> Rename</span>
      </div>
      <div
        class="flex gap-2 p-2 cursor-pointer hover:bg-[#CC00991A] hover:rounded-2xl"
        @click="props.onClickDeleteConversation(cData.operation.activeMenu)"
      >
        <img
          class="min-w-5 min-h-5 max-w-5 max-h-5"
          src="/images/icons/ic-trash-area-fill.svg"
          alt="delete"
        />
        <span class="text-[#9457EB] text-sm"> Delete</span>
      </div>
      <div
        class="flex gap-2 p-2 cursor-pointer hover:bg-[#CC00991A] hover:rounded-2xl"
        @click="props.onClickExportConversation(cData.operation.activeMenu)"
      >
        <img
          class="min-w-5 min-h-5 max-w-5 max-h-5"
          src="/images/icons/ic-arrow-up-on-square-area-fill.svg"
          alt="export"
        />
        <span class="text-[#9457EB] text-sm"> Export File</span>
      </div>
      <div
        class="flex gap-2 p-2 cursor-pointer hover:bg-[#CC00991A] hover:rounded-2xl"
        @click="props.onClickShareConversation(cData.operation.activeMenu)"
      >
        <img
          class="min-w-5 min-h-5 max-w-5 max-h-5"
          src="/images/icons/ic-share-area-fill-purple.svg"
          alt="share"
        />
        <span class="text-[#9457EB] text-sm"> Share</span>
      </div>
    </div>
  </div>
  <!-- :size="cData.isMobileSize ? 'small' : 'medium'" -->

  <!-- Search PromptStart -->
  <ModalSearch
    v-if="cData.isShowInputSearchPromptStart"
    :size="'small'"
    :showIconClose="true"
    :showIcon="false"
    :showButton2nd="true"
    :showTitle="true"
    :iconSwap="false"
    :slotSwap="false"
    :onClose="
      () => {
        cData.isShowInputSearchPromptStart = false;
      }
    "
    textTitle="Search"
    :optionList="props.promptStartList"
    :onChangeSelect="onChangeSelectedPromptStart"
  />
  <!-- Search Room -->
  <ModalSearch
    v-if="cData.isShowInputSearchRoom"
    :size="'small'"
    :showIconClose="true"
    :showIcon="false"
    :showButton2nd="true"
    :showTitle="true"
    :iconSwap="false"
    :slotSwap="false"
    :onClose="
      () => {
        cData.isShowInputSearchRoom = false;
      }
    "
    textTitle="Search"
    :optionList="props.roomList"
    :onChangeSelect="onChangeSelectedRoom"
  />
</template>

<script setup>
const componentName = 'SidebarLLM';

// Emit definition
const emit = defineEmits(['closeSidebar']);

// Props types: String, Number, Boolean, Array, Object, Function, Promise
const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {},
  },
  menuList: {
    type: Array,
    default: [],
  },
  generalList: {
    type: Array,
    default: [],
  },
  roomList: {
    type: Array,
    default: [],
  },
  promptStartList: {
    type: Array,
    default: [],
  },
  logoImage: {
    type: String,
    default: '/images/logos/logo-sidebar.png',
  },
  heightItem: {
    type: Number,
  },
  heightItemUnit: {
    type: String,
  },
  onClickLogo: {
    type: Function,
    default: function () {},
  },
  onClickSubMenu: {
    type: Function,
    default: function () {},
  },
  onClickCreateConversation: {
    type: Function,
    default: function () {},
  },
  onClickRenameConversation: {
    type: Function,
    default: function () {},
  },
  onClickDeleteConversation: {
    type: Function,
    default: function () {},
  },
  onClickRoom: {
    type: Function,
    default: function () {},
  },
  onClickPromptStart: {
    type: Function,
    default: function () {},
  },
  onClickExportConversation: {
    type: Function,
    default: function () {},
  },
  onClickShareConversation: {
    type: Function,
    default: function () {},
  },
  onLoadMore: {
    type: Function,
    default: async () => {},
  },
  onLoadMoreGeneral: {
    type: Function,
    default: async () => {},
  },
  onClickSearchConversation: {
    type: Function,
    default: () => {},
  },
});

const gConversationActiveId = useConversationActiveId();
const gPresetActiveId = usePresetActiveId();
const gPromptStartActiveId = usePromptStartActiveId();
const gConversationData = useConversationData();
console.log('gConversationData', gPresetActiveId, gConversationActiveId, gPromptStartActiveId);

const { $moment } = useNuxtApp();

const conversationListRef = ref(null);
const generalListRef = ref(null);
const isLoadingMore = ref(false);

const cData = reactive({
  isCollapsed: true,
  isShowInputSearch: false,
  isShowInputSearchPromptStart: false,
  isShowInputSearchRoom: false,
  isShowOverlay: false,
  searchValue: '',
  operation: {
    show: false,
    activeIndex: null,
    activeMenu: null,
    position: { top: 0, left: 0 },
  },
  isMobileSize: false,
  isShowInputSearchGeneral: false,
});

const generalGroupList = computed(() => {
  let dataGroupList = [
    {
      groupName: '',
      endDate: $moment().subtract(7, 'days'),
      dataList: [],
    },
    {
      groupName: '7 days before',
      startDate: $moment().subtract(30, 'days'),
      endDate: $moment().subtract(7, 'days'),
      dataList: [],
    },
    {
      groupName: '30 days before',
      startDate: $moment().subtract(30, 'days'),
      dataList: [],
    },
  ];


  console.log('dataGroupList', props.generalList, dataGroupList);
  props.generalList.forEach((e) => {
    if (e.name.toLowerCase().indexOf(cData.searchValue.toLowerCase()) >= 0) {
      dataGroupList = dataGroupList.map((ed) => {
        if (
          !ed.startDate &&
          ed.endDate &&
          $moment(e.createdAt).isAfter(ed.endDate)
        ) {
          ed.dataList.push(e);
        }
        if (
          ed.startDate &&
          ed.endDate &&
          $moment(e.createdAt).isBetween(ed.startDate, ed.endDate, null, '(]')
        ) {
          ed.dataList.push(e);
        }
        if (
          ed.startDate &&
          !ed.endDate &&
          $moment(e.createdAt).isSameOrBefore(ed.startDate)
        ) {
          ed.dataList.push(e);
        }
        return ed;
      });
    }
  });
  return dataGroupList;
});

const conversationGroupList = computed(() => {
  let dataGroupList = [
    {
      groupName: '',
      endDate: $moment().subtract(7, 'days'),
      dataList: [],
    },
    {
      groupName: '7 days before',
      startDate: $moment().subtract(30, 'days'),
      endDate: $moment().subtract(7, 'days'),
      dataList: [],
    },
    {
      groupName: '30 days before',
      startDate: $moment().subtract(30, 'days'),
      dataList: [],
    },
  ];


  console.log('dataGroupList', props.menuList, dataGroupList);
  props.menuList.forEach((e) => {
    if (e.name.toLowerCase().indexOf(cData.searchValue.toLowerCase()) >= 0) {
      dataGroupList = dataGroupList.map((ed) => {
        if (
          !ed.startDate &&
          ed.endDate &&
          $moment(e.createdAt).isAfter(ed.endDate)
        ) {
          ed.dataList.push(e);
        }
        if (
          ed.startDate &&
          ed.endDate &&
          $moment(e.createdAt).isBetween(ed.startDate, ed.endDate, null, '(]')
        ) {
          ed.dataList.push(e);
        }
        if (
          ed.startDate &&
          !ed.endDate &&
          $moment(e.createdAt).isSameOrBefore(ed.startDate)
        ) {
          ed.dataList.push(e);
        }
        return ed;
      });
    }
  });
  return dataGroupList;
});

const onChangeInput = (target, value) => {
  console.log('onChangeInput', target, value);
  cData[target] = value;
};

const toggleSidebar = () => {
  cData.isCollapsed = !cData.isCollapsed;
  emit('closeSidebar');
};

const toggleOperation = async (ev, item) => {
  if (cData.operation.activeIndex === item.id && cData.operation.show) {
    cData.operation.show = false;
    return;
  }

  cData.operation.show = true;
  cData.operation.activeIndex = item.id;
  cData.operation.activeMenu = item;

  const rect = ev.currentTarget.getBoundingClientRect();
  const menuHeight = 180; 
  const padding = 8; 
  let top = rect.bottom + window.scrollY + padding;
  
  if (top + menuHeight > window.innerHeight + window.scrollY) {
    top = rect.top + window.scrollY - menuHeight - padding;
    if (top < 0) top = 0;
  }
  cData.operation.position = {
    top,
    left: rect.left + window.scrollX,
  };
  await nextTick();
};

const closeOperation = (event) => {
  if (cData.operation.show) {
    cData.operation.show = false;
    cData.operation.activeMenu = null;
  }
};

const onChangeSelected = (item) => {
  const data = props.menuList.filter((e) => e.id === item)[0];
  if (data) {
    props.onClickSubMenu(data);
  }
  cData.isShowInputSearch = false;
};

const onChangeSelectedGeneral = (item) => {
  const data = props.generalList.filter((e) => e.id === item)[0];
  if (data) {
    props.onClickSubMenu(data);
  }
  cData.isShowInputSearchGeneral = false;
};

const onChangeSelectedPromptStart = (item) => {
  const data = props.promptStartList.filter((e) => e.id === item)[0];
  if (data) {
    props.onClickPromptStart(data);
  }
  cData.isShowInputSearchPromptStart = false;
};

const onChangeSelectedRoom = (item) => {
  const data = props.roomList.filter((e) => e.id === item)[0];
  if (data) {
    props.onClickRoom(data);
  }
  cData.isShowInputSearchRoom = false;
};

const handleScrollRoom = async (event) => {
  if (isLoadingMore.value) return;
  
  const element = event.target;
  const scrollTop = element.scrollTop;
  const scrollHeight = element.scrollHeight;
  const clientHeight = element.clientHeight;
  
  if (scrollTop + clientHeight >= scrollHeight - 10) {
    isLoadingMore.value = true;
    try {
      await props.onLoadMore();
    } finally {
      isLoadingMore.value = false;
    }
  }
};

const handleScrollGeneral = async (event) => {
  if (isLoadingMore.value) return;
  
  const element = event.target;
  const scrollTop = element.scrollTop;
  const scrollHeight = element.scrollHeight;
  const clientHeight = element.clientHeight;
  
  if (scrollTop + clientHeight >= scrollHeight - 10) {
    isLoadingMore.value = true;
    try {
      await props.onLoadMoreGeneral();
    } finally {
      isLoadingMore.value = false;
    }
  }
};



const handleSearchConversation = async () => {
  await props.onClickSearchConversation('room');
  cData.isShowInputSearch = true;
};

const handleSearchGeneral = async () => {
  await props.onClickSearchConversation('general');
  cData.isShowInputSearchGeneral = true;
};

onMounted(() => {
  if (window.innerWidth < 1024) {
    cData.isCollapsed = false;
    cData.isShowOverlay = true;
  } else {
    cData.isCollapsed = true;
    cData.isShowOverlay = false;
  }

  if (window.innerWidth <= 480) {
    cData.isMobileSize = true;
  }

  window.addEventListener('resize', () => {
    cData.isCollapsed = window.innerWidth >= 1024;
    cData.isShowOverlay = window.innerWidth < 1024;
  });
  document.addEventListener('click', closeOperation);
});
</script>

<style lang="scss">
/* Component variables */
.sidebar-llm-custom {
  /* Parent style   ------------------------------ */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: $specific-sidebar-navigation-width;
  padding: $py-6 $px-6;
  background-color: $color-base-white;
  height: 100vh;
  border-right: 1px solid $color-secondary-2-s-200;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  position: relative;
  font-family: $typography-font-family-primary;

  background: linear-gradient(175.33deg, #734EB0 0%, #330066 100%);


  /* Children style ------------------------------ */
  .sidebar-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    .is-logo {
      margin-bottom: 20px;

      img {
        width: 32px;
        height: 32px;
      }
    }

    .sidebar-header {
      height: 56px;
      padding: 0;
      gap: 16px;
      font-family: $typography-font-family-primary;
      font-size: $semantic-text-title-2xs-font-size;
      font-weight: $semantic-text-title-font-weight;
    }

    .sidebar-lists {
      @include button-transition();
      overflow-y: overlay;
      width: 100%;

      .button-box {
        height: $semantic-dimension-cta-height-md;
        padding: $py-2 $px-2 $py-2 $px-2;
        border-radius: 1rem;

        .sidebar-button {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: $space-y-3;
          cursor: pointer;

          .sidebar-image img {
            width: $semantic-dimension-icon-md;
            height: $semantic-dimension-icon-md;
            filter: brightness(0) saturate(100%) invert(46%) sepia(18%)
              saturate(284%) hue-rotate(182deg) brightness(93%) contrast(92%);
          }

          .sidebar-image-sub img {
            width: $semantic-dimension-icon-sm;
            height: $semantic-dimension-icon-sm;
            filter: brightness(0) saturate(100%) invert(46%) sepia(18%)
              saturate(284%) hue-rotate(182deg) brightness(93%) contrast(92%);
          }

          .rotate-img {
            transform: rotate(90deg);
          }

          .sidebar-text {
            font-family: $typography-font-family-primary;
            font-size: $semantic-text-body-md-font-size;
            font-weight: 400;
            line-height: $semantic-text-body-lg-line-height;
            text-align: left;
            color: white;
          }

          &.is-selected {
            .sidebar-text {
              color: #7451ad;
            }
          }
        }

        &.is-active {
          background: $specific-sidebar-navigation-background-active;
          &:hover {
            background: $specific-sidebar-navigation-background-active;
          }
        }

        &.is-selected {
          cursor: default;
          background: $specific-sidebar-navigation-background-selected;
          .sidebar-button {
            .sidebar-text {
              color: $specific-sidebar-navigation-foreground-selected;
            }
            .sidebar-image {
              img {
                filter: brightness(0) invert(1);
              }
            }
          }

          &:hover {
            background: $specific-sidebar-navigation-background-selected;
          }
        }

        &:hover {
          background-color: $specific-sidebar-navigation-background-hover;
        }
      }
    }
  }

  &.sidebar-llm {
    .sidebar-section {
      .sidebar-lists {
        margin: 0;
        /* max-width: 240px; */
        .button-box {
          color: #cbd5e1;
          border-radius: 1rem;
          margin-bottom: 2rem;
          &.is-active {
            background: white;
            &:hover {
              background: white;
            }
          }

          &.is-selected {
            cursor: default;
            background: #ffffff1a;
            display: flex;
            align-items: center;
            justify-content: center;
            .sidebar-button {
              .sidebar-text {
                color: #ffffff;
                font-size: $semantic-text-body-md-font-size;
                flex: none;
              }

              .sidebar-image {
                img {
                  filter: none;
                }
              }
            }

            &:hover {
              background: #8b7cb1;
              opacity: 0.75;
            }
          }
        }
        .button-box-conversation {
          height: $semantic-dimension-cta-height-md;
          padding: $py-2 0 $py-2 0;
          border-radius: $semantic-dimension-cta-rounded-md;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .sidebar-button {
            display: flex;
            align-items: center;
            gap: $space-y-3;
            width: 100%;
            padding: 8px;
            cursor: pointer;

            .sidebar-image img {
              width: $semantic-dimension-icon-md;
              height: $semantic-dimension-icon-md;
            }

            .sidebar-image-sub img {
              width: $semantic-dimension-icon-sm;
              height: $semantic-dimension-icon-sm;
              filter: brightness(0) saturate(100%) invert(46%) sepia(18%)
                saturate(284%) hue-rotate(182deg) brightness(93%) contrast(92%);
            }

            .rotate-img {
              transform: rotate(90deg);
            }

            .sidebar-text {
              font-family: $typography-font-family-primary;
              font-size: $semantic-text-body-md-font-size;
              font-weight: 400;
              line-height: 28px;
              text-align: left;
              color: white;
            }

            &.is-selected {
              background-color: #734EB0;
              border-radius: 9999px;
              .sidebar-text {
                color: #FFFFFF;
              }
            }

            &.is-selected-oth {
              background-color: #CC0099;
              border-radius: 9999px;
              .sidebar-text {
                color: #FFFFFF;
              }
            }

            &:hover {
              background-color: #ffffff4a;
              border-radius: 9999px;
            }
          }

          &.is-active {
            background: $specific-sidebar-navigation-background-active;
            &:hover {
              background: $specific-sidebar-navigation-background-active;
            }
          }

          &.is-selected {
            cursor: default;
            .sidebar-button {
              background-color: $specific-sidebar-navigation-background-hover;
              .sidebar-text {
                color: $specific-sidebar-navigation-foreground-selected;
              }
              .sidebar-image {
                img {
                  filter: brightness(0) invert(1);
                }
              }
            }

            &:hover {
              background: $specific-sidebar-navigation-background-selected;
            }
          }
        }
      }
    }
  }

  .sidebar-operation {
    position: absolute;
    z-index: 99;
    margin: 0;
    min-width: 159px;
    max-width: 159px;
    border-radius: 1rem;
    padding: 8px;
    border-width: 1px;
    border: 1px solid #330066;
    background: #E8E1F8;
    box-shadow: $shadow-general-x $shadow-general-y
      $shadow-general-blur$shadow-general-spread $shadow-general-color;
  }
}
</style>
